import { styled, Card as MuiCard, Typography as MuiTypography } from '@material-ui/core';
import { ArrowForwardIos } from '@material-ui/icons';

import { COLORS } from 'theme/constants';

export const Card = styled(MuiCard)({
  padding: '24px 29px',
  '&.builder': {
    padding: '20px',
    margin: '10px 0',
    background: COLORS.builderInputFieldBg,
    border: `1px solid ${COLORS.builderButtonColor}`,
    color: COLORS.builderSubTitleColor,
  },
  '&.builder .MuiTypography-h2': {
    color: COLORS.white,
  },
  '&.builder .MuiTypography-body1': {
    color: COLORS.builderSubTitleColor,
  },
});

export const CardText = styled(MuiTypography)({
  color: COLORS.greyText,
  fontSize: '14px',
  opacity: 0.8,
});

export const ArrowForwardIcon = styled(ArrowForwardIos)({
  fontSize: 12,
});
